import { render, staticRenderFns } from "./TheCotizacionesTable.vue?vue&type=template&id=0b8eb2a4&scoped=true"
import script from "./TheCotizacionesTable.vue?vue&type=script&lang=js"
export * from "./TheCotizacionesTable.vue?vue&type=script&lang=js"
import style0 from "./TheCotizacionesTable.vue?vue&type=style&index=0&id=0b8eb2a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8eb2a4",
  null
  
)

export default component.exports